export default {
  scroll: 'SCROLL',
  detail: 'DETAIL',
  navigation: 'NAVIGATION'
}